<ng-content select="[modalError]"></ng-content>
<ng-content select="[modalWarning]"></ng-content>
<ng-content select="[modalSuccess]"></ng-content>
<ng-content select="[modalInfo]"></ng-content>